<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="create-project-lead-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
          </button>

          <h4 class="modal-title">
            Create Project Lead
          </h4>
        </div>

        <div class="modal-body">
          <ul class="nav nav-tabs" role="tablist">
            <li role="presentation" class="active">
              <a href="#search" aria-controls="search" role="tab" data-toggle="tab">Search</a>
            </li>

            <li role="presentation">
              <a href="#create" aria-controls="create" role="tab" data-toggle="tab">Create</a>
            </li>
          </ul>

          <div class="tab-content" style="padding-top: 15px;">
            <div role="tabpanel" class="tab-pane active" id="search">
              <SearchForm
                  :project="project"
                  @created="created"
              />
            </div>

            <div role="tabpanel" class="tab-pane" id="create">
              <CreateForm
                  :project="project"
                  @created="created"
              />
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchForm from "./CreateForms/SearchForm.vue";
import CreateForm from "./CreateForms/CreateForm.vue";

export default {
  components: {CreateForm, SearchForm},

  props: {
    project: {
      required: true
    },
  },

  methods: {
    created(projectLead) {
      this.$emit('created', projectLead)

      $(this.$el).modal('hide')
    }
  }
}
</script>
